import { render, staticRenderFns } from "./AdditionalInfoDraftDialog.vue?vue&type=template&id=c6e9024c&scoped=true"
import script from "./AdditionalInfoDraftDialog.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoDraftDialog.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfoDraftDialog.vue?vue&type=style&index=0&id=c6e9024c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e9024c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e9024c')) {
      api.createRecord('c6e9024c', component.options)
    } else {
      api.reload('c6e9024c', component.options)
    }
    module.hot.accept("./AdditionalInfoDraftDialog.vue?vue&type=template&id=c6e9024c&scoped=true", function () {
      api.rerender('c6e9024c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/AdditionalInfoDraftDialog.vue"
export default component.exports